import { axiosInstance } from "../../axios/axiosInstance";
import { ADMIN_API_URL, getDefaultHeaders } from "../../config";

const authHeaders = (extra = {}) => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
    ...extra,
  };
};

export const getInvoices = (params = {}) =>
  axiosInstance.get(`${ADMIN_API_URL}/invoices`, {
    headers: authHeaders(),
    params,
  });

export const downloadInvoice = (publicId) =>
  axiosInstance.get(`${ADMIN_API_URL}/invoices/download/${publicId}`, {
    headers: authHeaders(),
  });

export const createInvoiceRequest = (invoiceData) =>
  axiosInstance.post(`${ADMIN_API_URL}/invoices`, invoiceData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });

export const deleteInvoiceRequest = (invoiceId) =>
  axiosInstance.delete(`${ADMIN_API_URL}/invoices/${invoiceId}`, {
    headers: authHeaders(),
  });

export const updateInvoiceRequest = (invoiceId, invoiceData) =>
  axiosInstance.post(`${ADMIN_API_URL}/invoices/${invoiceId}`, invoiceData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });

export const getInvoiceCounts = () =>
  axiosInstance.get(`${ADMIN_API_URL}/invoices_count_list`, {
    headers: authHeaders(),
  });

export const getPaymentTypes = () =>
  axiosInstance.get(`${ADMIN_API_URL}/get-payment-types`, {
    headers: authHeaders(),
  });

export const getZatcaTypes = () =>
  axiosInstance.get(`${ADMIN_API_URL}/zatca_types`, {
    headers: authHeaders(),
  });

export const getEligibleInvoices = (zatca_type_id) =>
  axiosInstance.post(
    `${ADMIN_API_URL}/zatca/eligible-invoices`,
    { zatca_type_id },
    { headers: authHeaders() },
  );

export const getUserDetails = (user_id) =>
  axiosInstance.get(`${ADMIN_API_URL}/user/details/${user_id}`, {
    headers: authHeaders(),
  });
